import PropTypes from 'prop-types'
import { Container, Paper } from '@mui/material'

import useStyles from './styles'

const ShippingSendForm = ({ children }) => {
  const classes = useStyles()

  return (
    <Paper elevation={1} className={classes.paper}>
      <Container className={classes.mainContainer}>{children}</Container>
    </Paper>
  )
}

ShippingSendForm.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ShippingSendForm
